export const InitialPriceEstimateQueryKeys = {
  all: () => ["initialPriceEstimate"],
  categories: (searchTerm: string, configured?: boolean) => [
    ...InitialPriceEstimateQueryKeys.all(),
    "categories",
    configured === undefined ? "any" : String(configured),
    searchTerm,
  ],
  single: (partCategoryId: string | undefined) => [
    ...InitialPriceEstimateQueryKeys.all(),
    partCategoryId,
  ],
  aiPrompt: () => [...InitialPriceEstimateQueryKeys.all(), "aiPrompt"],
};
